<template>
  <div class="dashboard-wrapper">
    <i18n class="dashboard dashboard-desktop" path="success.dashboard.desktop.title" tag="p">
      <template v-slot:link>
        <a
          :href="dashboardUrl"
          target="_blank"
          rel="noopener"
          v-t="'success.dashboard.desktop.link'"
        />
      </template>
    </i18n>
    <i18n class="dashboard dashboard-mobile" path="success.dashboard.mobile.title" tag="p">
      <template v-slot:link>
        <a
          :href="dashboardUrl"
          target="_blank"
          rel="noopener"
          v-t="'success.dashboard.mobile.link'"
        />
      </template>
    </i18n>
  </div>
</template>

<script>
import store from '@/store';
import { getDashboardUrl } from '@/utils/getSiteUrls';

export default {
  computed: {
    dashboardUrl: () => getDashboardUrl(store),
  },
};
</script>

<style scoped src="./successPaymentDashboard.css"></style>
